






















































































































































































import { Component, Vue } from 'vue-property-decorator'

import CategoryUserList from './partials/CategoryUserList.vue'
import DeviceList from './partials/DeviceList.vue'
import RFIDReaderListener from './partials/RFIDReaderListener.vue'
import UserModel from '@/_models/UserModel'
import CardModel from '@/_models/CardModel'
import BeaconModel from '@/_models/BeaconModel'
import { cloneDeep } from 'lodash'
import { linkedDeviceDetect } from '../../_worker/web-worker-api'
import { LinkDetectedDevice } from '@/_enums/link_devices_detect'

@Component({
  components: {
    CategoryUserList,
    DeviceList,
    RFIDReaderListener,
  },
})
export default class LinkListMixin extends Vue {
  user: any = new UserModel()
  card: any = new CardModel()
  beacon: any = new BeaconModel()

  async onFilterByCode(code: string) {
    const refComponent = this.$refs.linkDeviceList as DeviceList
    const uRefCompoennt = this.$refs.linkCategoryUserList as CategoryUserList
    const linkRefComponent = this.$refs.linkDeviceList as DeviceList
    const users = uRefCompoennt.users
    const cards = refComponent.cards
    const beacons = refComponent.beacons

    const resp = await linkedDeviceDetect(code, users, beacons, cards)

    if (resp) {
      switch (resp.type) {
        case LinkDetectedDevice.user:
          if (resp.data?.category_id) {
            uRefCompoennt.findCategoryById(resp.data.category_id)
          }
          uRefCompoennt.userSelected = resp.data

          this.userSelected(resp.data)
          break

        case LinkDetectedDevice.beacon:
          linkRefComponent.onBeaconSelected(resp.data)
          linkRefComponent.onSelectDeviceTypeByName(LinkDetectedDevice.beacon)
          break

        case LinkDetectedDevice.card:
          linkRefComponent.onCardSelected(resp.data)
          linkRefComponent.onSelectDeviceTypeByName(LinkDetectedDevice.card)
          break

        default:
          linkRefComponent.onBack()
          uRefCompoennt.onBack()
          break
      }
    }
  }

  userSelected(user: UserModel): void {
    const oldUSelected = cloneDeep(this.user) as UserModel
    // When select new user with linked => trigger auto show detail
    if (oldUSelected._id !== user._id && (user.beacon_id || user.san_id)) {
      ;(this.$refs.linkDeviceList as DeviceList).onAutoSelectDevice(user.beacon_id || user.san_id, !!user.san_id)
    }

    this.user = user
  }

  onDeviceSelected(userId: string) {
    if (userId) {
      const user = (this.$refs.linkCategoryUserList as CategoryUserList).unEmitSelectedUser(userId)
      if (user) {
        this.user = user
      }
    }
  }

  cardSelected(card: CardModel): void {
    this.card = card
  }

  beaconSelected(beacon: BeaconModel): void {
    this.beacon = beacon
  }

  canLink(): boolean {
    return !this.user.card_id && !this.user.beacon_id && !this.card.user_id && !this.beacon.user_id
  }

  canUnLink(): boolean {
    return (
      (this.card.user_id && this.user.san_id === this.card.san_id) ||
      (this.beacon.user_id && this.user.beacon_id === this.beacon._id)
    )
  }

  get isLoading(): boolean {
    return this.$store.state.users.loading
  }

  onClickLink(): void {
    let userLinked: UserModel = this.user
    let cardLinked: CardModel = this.card
    let beaconLinked: BeaconModel = this.beacon
    if (this.card._id) {
      // The user link with card
      userLinked = {
        ...userLinked,
        card_id: this.card._id,
        card_type: this.card.card_type,
        san_id: this.card.san_id,
      }
      cardLinked = {
        ...cardLinked,
        user_id: this.user._id,
        user_name: this.user.name,
      }
    }
    if (this.beacon._id) {
      // The user link with beacon
      userLinked = {
        ...userLinked,
        beacon_id: this.beacon._id,
        beacon_type: this.beacon.beacon_type,
        major: this.beacon.major,
        minor: this.beacon.minor,
      }
      beaconLinked = {
        ...beaconLinked,
        user_id: this.user._id,
        user_name: this.user.name,
      }
    }
    this.$store.dispatch('users/updateOne', userLinked).then(() => {
      this.$buefy.toast.open(this.$t('messages.update_success') as string)
      this.user = userLinked
      this.card = cardLinked
      this.beacon = beaconLinked
      this.$forceUpdate()
    })
  }

  onClickUnLink(): void {
    let userUnLinked: UserModel = this.user
    let cardUnLinked: CardModel = this.card
    let beaconUnLinked: BeaconModel = this.beacon
    if (this.card._id) {
      // The user unlink with card
      userUnLinked = {
        ...userUnLinked,
        card_id: '',
        card_type: '',
        san_id: '',
      }
      cardUnLinked = {
        ...cardUnLinked,
        user_id: '',
        user_name: '',
      }
    }
    if (this.beacon._id) {
      // The user unlink with beacon
      userUnLinked = {
        ...userUnLinked,
        beacon_id: '',
        beacon_type: '',
        major: '',
        minor: '',
      }
      beaconUnLinked = {
        ...beaconUnLinked,
        user_id: '',
        user_name: '',
      }
    }

    this.$store.dispatch('users/updateOne', userUnLinked).then(() => {
      this.$buefy.toast.open(this.$t('messages.update_success') as string)
      this.user = userUnLinked
      this.card = cardUnLinked
      this.beacon = beaconUnLinked
      this.$forceUpdate()
    })
  }
}
